module.exports = __webpack_public_path__ + "img/company_8.aeae80b0.png";